import React from 'react';
import styles from './QuickStats.module.css';

function formatNumber(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000) return Math.round(n / 1000) + 'K';
  return n.toString();
}

const QuickStats = ({ logbook, streak }) => (
  <div className={styles.Grid}>
    <div className={styles.StatBox}>
      <p className={styles.Value}>{logbook.total_workouts != null ? logbook.total_workouts : '-'}</p>
      <p className={styles.Label}>Workouts</p>
      {streak != null && streak > 0 && (
        <p className={styles.Streak}>Streak: {streak}</p>
      )}
    </div>
    <div className={styles.StatBox}>
      <p className={styles.Value}>
        {logbook.workouts_per_week != null ? Number(logbook.workouts_per_week).toFixed(1) : '-'}
      </p>
      <p className={styles.Label}>Per Week</p>
    </div>
    <div className={styles.StatBox}>
      <p className={styles.Value}>
        {logbook.total_pounds_lifted != null ? formatNumber(Number(logbook.total_pounds_lifted)) : '-'}
      </p>
      <p className={styles.Label}>Lbs Lifted</p>
    </div>
  </div>
);

export default QuickStats;
